import { useCallback } from 'react';
import Button from '../../../../components/UI/Button/Button';
import useTranslations from '../../../../hooks/useTranslations';
import './AddCustomerAssignmentsFromFile.scss';
import {
  IImportedAssignmentItem,
  readCustomerAssignmentsFile,
  generateCustomerAssignmentsExampleURL,
} from '../../../../utils/customerAssignmentsExcel';

interface IAddCustomerAssignmentsFromFileProps {
  setAssignments: React.Dispatch<
    React.SetStateAction<IImportedAssignmentItem[]>
  >;
}

const AddCustomerAssignmentsFromFile = ({
  setAssignments,
}: IAddCustomerAssignmentsFromFileProps) => {
  const { rcTranslate } = useTranslations();

  const handleUploadClick = useCallback(() => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xlsx,.xls';
    input.style.display = 'none';
    document.body.appendChild(input);

    input.onchange = async (e: any) => {
      const file: File | undefined = e.target.files?.[0];
      if (!file) return;
      try {
        const items = await readCustomerAssignmentsFile(file, rcTranslate);
        if (items.length === 0) {
          alert(
            rcTranslate(
              'customerAssignments.insertRange.noValidAssignmentsFoundInFile'
            )
          );
        } else setAssignments(items);
      } catch (err) {
        console.error('Failed processing assignments file', err);
      } finally {
        input.value = '';
      }
    };

    input.click();
  }, [setAssignments, rcTranslate]);

  const handleDownloadExample = useCallback(async () => {
    try {
      const url = await generateCustomerAssignmentsExampleURL(rcTranslate);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${rcTranslate('customerAssignments.insertRange.customerAssignmentsExampleFileName')}.xlsx`;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 0);
    } catch (err) {
      console.error('Failed generating example file', err);
    }
  }, [rcTranslate]);

  return (
    <div className="addCustomerAssignmentsFromFile">
      <Button
        title={rcTranslate('customerAssignments.insertRange.addFromFile')}
        type="button"
        onClick={handleUploadClick}
        className="addCustomerAssignmentsFromFileButton"
      />
      <Button
        title={rcTranslate('customerAssignments.insertRange.downloadExample')}
        type="button"
        onClick={handleDownloadExample}
        className="downloadCustomerAssignmentsExampleButton"
      />
    </div>
  );
};

export default AddCustomerAssignmentsFromFile;
